import { gql } from '@apollo/client';
import ProductPrice from '../ProductPrice/ProductPrice';
import RelatedProductSelector from '../../../RelatedProductSelector/RelatedProductSelector';
import { AssetFragment } from '../../../../graphql/fragments/Asset';

export const ProductDetailsFragment = gql`
  fragment ProductDetailsFragment on Product {
    details {
      id
      title
      care
      description
      composition
      features {
        description
        id
        title
        image {
          ...AssetFragment
        }
      }
      imported
    }
    colors {
      id
      swatch {
        file {
          url
        }
        id
        title
      }
      title
    }
    sizes {
      id
      title
      options {
        id
        value
        guidance
      }
    }
    demographics {
      age
      gender
    }
    sizeGuideInputs {
      age
      gender
      sizeRangeId
      styleTagId
    }
    variants {
      id
      available
      categories
      color {
        id
        title
        swatch {
          id
        }
      }
      externalSystems {
        shopify
      }
      images {
        id
        title
        type
        image {
          description
          id
          title
          file {
            url
          }
        }
      }
      itemCount
      pack
      sizes {
        id
        title
        value
      }
      sku
      virtual
      weight {
        unit
        value
      }
      imported
      replenishable
      components {
        endUse
        endUse2
        primaryMaterial
        lifestyle
      }
      ...ProductPriceFragment
    }
    ...RelatedProductsFragment
  }
  ${ProductPrice.fragment}
  ${RelatedProductSelector.fragment}
  ${AssetFragment}
`;

export default {};
